const FinishType = {
    CANCEL: "cancel",
    COMPLETED: "completed",
    PENDING: "pending",
    TIMEOUT: "timeout"
}

export default FinishType
